"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBadge = exports.BadgeText = exports.BadgeDotColor = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledBadge = exports.StyledBadge = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1mdhi6e-0"
})([""]);
var BadgeText = exports.BadgeText = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1mdhi6e-1"
})(["", ""], function (props) {
  return props.$text && (0, _ykbStyledComponents.css)(["font-weight:400;size:13px;line-height:18px;width:38px;height:18px;gap:0px;opacity:0px;color:#000000;"]);
});
var BadgeDotColor = exports.BadgeDotColor = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1mdhi6e-2"
})(["", ""], function (props) {
  return props.$colorDot && (0, _ykbStyledComponents.css)(["height:", ";width:", ";background-color:", ";border-radius:50%;display:inline-block;margin-right:", ";margin-top:2px;"], function (props) {
    return props.$text ? '10px' : '6px';
  }, function (props) {
    return props.$text ? '10px' : '6px';
  }, function (props) {
    return props.$colorDot;
  }, function (props) {
    return props.$text ? '5px' : '0';
  });
});